import { Carousel } from '@mantine/carousel';
import { AppShell, Center, Loader, Tabs } from '@mantine/core';
import { useUnit } from 'effector-react';
import { FolderTree } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { createShiftRegistry } from 'entities/shift';
import { useBreakpoint } from 'shared/lib';
import { Empty } from 'shared/ui';
import { shiftsPageModel } from '../../model';
import { ShiftsPageCurrent } from '../shifts-page-current';
import { ShiftsPagePrev } from '../shifts-page-prev';
import cls from './shifts-page.module.scss';

const ShiftsRegistry = createShiftRegistry(shiftsPageModel.shiftRegistryModel);

export const ShiftsPage = () => {
	const { t } = useTranslation();

	const [isEmpty, pending, isPrevShift] = useUnit([
		shiftsPageModel.$isEmpty,
		shiftsPageModel.$pending,
		shiftsPageModel.$isPrevShift,
	]);

	const sm = useBreakpoint('sm');

	if (pending)
		return (
			<AppShell.Main className={cls.shiftsPage}>
				<Center>
					<Loader />
				</Center>
			</AppShell.Main>
		);

	if (isEmpty)
		return (
			<AppShell.Main className={cls.shiftsPage}>
				<Empty
					icon={<FolderTree />}
					title={t('shifts-page.empty.title')}
					message={t('shifts-page.empty.message')}
				/>
			</AppShell.Main>
		);

	return (
		<AppShell.Main className={cls.shiftsPage}>
			<Tabs
				variant='pills'
				defaultValue='shift'
				classNames={{
					root: cls.shiftsPageTabs,
					panel: cls.shiftsPageTabsPanel,
				}}
				keepMounted={false}
			>
				<Tabs.List>
					<Carousel
						slideSize='auto'
						slideGap={9}
						emblaOptions={{ dragFree: true }}
					>
						<Carousel.Slide>
							<Tabs.Tab
								value='shift'
								size={sm ? 'xl' : 'lg'}
							>
								{isPrevShift ? t('shifts-page.previous-shift') : t('shifts-page.current-shift')}
							</Tabs.Tab>
						</Carousel.Slide>
						<Carousel.Slide>
							<Tabs.Tab
								size={sm ? 'xl' : 'lg'}
								className={cls.shiftsPageTabsTabRegistry}
								value='my-shifts'
							>
								{t('shifts-page.my-shifts')}
							</Tabs.Tab>
						</Carousel.Slide>
					</Carousel>
				</Tabs.List>
				<Tabs.Panel
					className={cls.shiftsPageTabsPanelShift}
					value='shift'
				>
					{isPrevShift ? <ShiftsPagePrev /> : <ShiftsPageCurrent />}
				</Tabs.Panel>
				<Tabs.Panel
					className={cls.shiftsPageTabsPanelRegistry}
					value='my-shifts'
				>
					<ShiftsRegistry />
				</Tabs.Panel>
			</Tabs>
		</AppShell.Main>
	);
};
